import { useState } from 'react'
import { useSelector } from 'react-redux'
import props from '../../../../../../redux/props'
import useConceptConfiguration from '../../ConceptCalculation/useConceptConfiguration'
import Modal from '../../../../../UI/Modal/Modal'
import Input from '../../../../../UI/Input/Input'
import { Concept } from '../../../../../../types/Survey/Analysis/Concept'
import { crud } from '@think-internet/zeus-frontend-package'
import useToast, { Type } from '../../../../../hooks/useToast'
import { DocumentDuplicateIcon } from '@heroicons/react/24/solid'

type Props = {
  concept: Concept
}

const Copy: React.FC<Props> = ({ concept }) => {
  const t = useSelector((s) => s[props.TRANSLATION])
  const [open, setOpen] = useState(false)
  const [name, setName] = useState(concept.name)
  const { addConcept, concepts } = useConceptConfiguration()
  const conceptFeature = crud.use(props.SURVEY_ANALYSIS_CONCEPT)
  const toast = useToast()

  const toggle = () => setOpen(!open)

  const triggerCopy = async () => {
    const payload: Concept = {
      index: concepts.length,
      surveyContextUUID: concept.surveyContextUUID,
      name,
      units: concept.units,
      optimization: concept.optimization,
      floorMapping: concept.floorMapping,
    }

    const createdConcept: Concept = await conceptFeature.create(payload)
    if (createdConcept) {
      addConcept(createdConcept)
      toggle()
    } else {
      toast(t.survey.analysis.concept.copy.error, Type.ERROR)
    }
  }

  return (
    <div className="flex justify-end">
      <DocumentDuplicateIcon className="fill-blue opacity-40 hover:opacity-100 transition-all w-5 cursor-pointer" onClick={toggle} />
      <Modal onConfirm={triggerCopy} show={open} onClose={toggle} title={`${concept.name}${t.survey.analysis.concept.copy.titleSuffix}`}>
        <div className="text-sm text-gray-500">{t.survey.analysis.concept.copy.hint}</div>
        <div className="flex flex-col gap-3 mt-3">
          <Input required label={t.generic.name} value={name} onChange={setName} />
        </div>
      </Modal>
    </div>
  )
}

export default Copy
